/** @typedef {import('headlight-configurable-application').Pict} Pict */
const PictProvider = require('pict-provider');

class LineItemProvider extends PictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
	}

	async _put(uri, payload)
	{
		return new Promise((resolve, reject) =>
		{
			this.pict.HeadlightRestClient.putJSON(uri, payload, (pError, pBody) =>
			{
				if (pError)
				{
					return reject(pError);
				}
				resolve(pBody);
			});
		});
	}

	/**
	 * Get the LineItem by ID
	 * @param {String|Number} pLineItemID - The LineItem ID to search for
	 * @return {Promise<void>}
	 * @async
	 */
	getLineItemByID(pLineItemID)
	{
		return new Promise((resolve, reject) =>
		{
			if (!pLineItemID)
			{
				this.pict.log.error('No LineItem ID provided.');
				return reject(new Error('No LineItem ID provided.'));
			}

			this.pict.HeadlightRestClient.getJSON(`LineItem/${pLineItemID}`, (pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error getting LineItem: ${pError}`, pError);
					return reject(pError);
				}
				resolve(pBody);
			});
		});
	}

	async saveSampleLineItemJoin(payload)
	{
		await this._put('SampleLineItemJoin/Upsert', payload);
	}

	/**
	 * Get the LineItems
	 * @return {Promise<void>}
	 * @async
	 * @example
	 */

	getLineItems()
	{
		return new Promise((resolve, reject) =>
		{
			let tmpURL = 'LineItems';

			// Check if we need to filter by customer ID
			if (this.pict.AppData?.DocumentData?.ReportData?.IDCustomer)
			{
				tmpURL = `LineItems/By/IDCustomer/${this.pict.AppData.DocumentData.ReportData.IDCustomer}`;
			}

			// Make the request to get LineItems
			this.pict.HeadlightRestClient.getJSON(tmpURL, (pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error('Failed to get LineItems list.', pError);
					return reject(pError);
				}

				resolve(pBody);
			});
		});
	}

	async _getSampleLineItemJoinsByIDSample(IDSample)
	{
		return new Promise((resolve, reject) =>
		{
			this.pict.HeadlightRestClient.getEntitySetWithPages('SampleLineItemJoin', `FBV~IDSample~EQ~${ IDSample }`, ()=>{}, ()=>{}, (pError, pRecords) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error getting SampleLineItemJoins: ${pError}`, pError);
					return reject(pError);
				}
				resolve(pRecords);
			});
		});
	}

	async _getLineItemsByIDs(IDLineItems)
	{
		return new Promise((resolve, reject) =>
		{
			this.pict.HeadlightRestClient.getEntitySetWithPages('LineItem', `FBL~IDLineItem~INN~${ IDLineItems.join(',') }`, ()=>{}, ()=>{}, (pError, pRecords) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error getting LineItems: ${pError}`, pError);
					return reject(pError);
				}
				resolve(pRecords);
			});
		});
	}

	async getLineItemsByIDSample(IDSample)
	{
		const slijs = await this._getSampleLineItemJoinsByIDSample(IDSample);
		if (!slijs?.length)
		{
			return [];
		}
		const lineItems = await this._getLineItemsByIDs(slijs.map(slij => slij.IDLineItem));
		const slijMap = [];
		for (let s of slijs)
		{
			slijMap[s.IDLineItem] = s;
		}
		const decoratedLineItems = [];
		for (let l of lineItems)
		{
			// Decorate the LI with the important join information.
			decoratedLineItems.push(Object.assign(l, { RepresentedQuantity: slijMap[l.IDLineItem].RepresentedQuantity, IDSampleLineItemJoin: slijMap[l.IDLineItem].IDSampleLineItemJoin, GUIDSampleLineItemJoin: slijMap[l.IDLineItem].GUIDSampleLineItemJoin }));
		}
		return decoratedLineItems;
	}

	async deleteSampleLineItemJoin(IDSampleLineItemJoin)
	{
		return await new Promise((resolve, reject) => 
		{
			this.pict.HeadlightRestClient.deleteEntity('SampleLineItemJoin', IDSampleLineItemJoin, (pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error removing lineitem from sample: `, pError);
					return reject(pError);
				}
				resolve(true);
			});
		});
	}
}

module.exports = LineItemProvider;
module.exports.default_configuration = {};
